import { z } from 'zod';

import { PersistableVault } from './PersistableVault';

interface PersistableVaultRepo {
  vaults: PersistableVault[];
}

const PersistableVaultRepo = z.object({
  vaults: z.array(PersistableVault),
});

export { PersistableVaultRepo };
